/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/* eslint-disable import/no-unresolved, import/default */

import bulkProvisioningTemplate from './bulk-provisioning/bulk-provisioning.dialog.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function GatewayTableConfig($q, $translate, $mdDialog, $document, $filter, $state, toast, types, utils, tkDialogs, userService,
                                           gatewayGroupService, gatewayService/*, customerService*/) {


    var gatewayStateSubscriptions = {};

    var service = {
        getConfig: getConfig
    };

    return service;

    function getConfig(params) {

        var deferred = $q.defer();

        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;
        var access = types.authority[authority].access;

        gatewayGroupService.getGatewayGroup(params.gatewayGroupId).then(
            (gatewayGroup) => {
                var tableConfiguration = createGatewayConfig(scope, access, params, gatewayGroup.name);
                deferred.resolve(tableConfiguration);
            },
            () => {
                deferred.reject();
            }
        );

        return deferred.promise;
    }

    function createGatewayConfig(scope, access, params, entityTitle) {

        var gatewayGroupId = params.gatewayGroupId;

        var tableConfiguration = {

            scope: scope,

            entityType: types.entityType.gateway,

            tableTitle: getTitle(scope, entityTitle),

            columns: [
                {
                    key: 'createdTime',
                    title: 'entity.createdTime'
                },
                {
                    key: 'name',
                    title: 'gateway.name'
                },
                {
                    key: 'mac',
                    title: 'gateway.mac'
                },
                {
                    key: 'gatewayModelName',
                    title: 'gateway-model.gateway-model'
                },
                {
                    key: 'public',
                    title: 'gateway.public',
                    boolean: true
                },
                {
                    key: 'logEnabled',
                    title: 'gateway.messages-logging',
                    boolean: true
                },
                {
                    key: 'online',
                    title: 'gateway.status',
                    cellContentFunction: (value, entity) => {
                        if (value && !entity.disabled) {
                            return $translate.instant('gateway.online');
                        } else {
                            return entity.disabled ? $translate.instant('gateway.disabled') : $translate.instant('gateway.offline');
                        }
                    },
                    cellStyleFunction: (value, entity) => {
                        if (value && !entity.disabled) {
                            return {color: '#1a901a'};
                        } else {
                            return {color: '#ff0000'};
                        }
                    }
                }
            ],

            addEntityController: 'AddGatewayController',
            bulkProvisioningTemplate: bulkProvisioningTemplate,
            bulkProvisioningController: 'GatewayBulkProvisioningController',

            loadEntities: ($scope) => {
                return loadGateways($scope, gatewayGroupId);
            },
            loadEntity: (entityId) => {
                return gatewayService.getGateway(entityId)
            },
            saveEntity: (entity) => {
                return gatewayService.saveGateway(entity)
            },
            deleteEntity: (entityId) => {
                return gatewayService.deleteGateway(entityId)
            },
            subscribeEntities: ($scope, entities) => {
                return subscribeForGatewaysState($scope, entities)
            },
            unsubscribeAllEntities: () => {
                unsubscribeFromGatewayStates()
            },

            onDestroy: () => {
                unsubscribeFromGatewayStates();
            },

            addEnabled: () => {
                return access == types.access.admin;
            },

            detailsReadOnly: () => {
                return access == types.access.user;
            },
            deleteEnabled: () => {
                return access == types.access.admin;
            },
            entitiesDeleteEnabled: () => {
                return access == types.access.admin;
            },
            deleteEntityTitle: (entity) => {
                return $translate.instant('gateway.delete-gateway-title', {name: entity.name});
            },
            deleteEntityContent: (/*entity*/) => {
                return $translate.instant('gateway.delete-gateway-text');
            },
            deleteEntitiesTitle: (count) => {
                return $translate.instant('gateway.delete-gateways-title', {count: count}, 'messageformat');
            },
            deleteEntitiesContent: (/*count*/) => {
                return $translate.instant('gateway.delete-gateways-text');
            }

        };

        tableConfiguration.manageCredentials = (event, entity) => {
            var isReadOnly = access == types.access.user ? true : false;
            manageCredentials(event, entity, isReadOnly);
        };

        tableConfiguration.actionCellDescriptors = [
            {
                name: 'gateway.move-to-gateway-group',
                icon: 'swap_vertical_circle',
                isEnabled: () => {
                    return access == types.access.admin;
                },
                onAction: ($event, entity) => {
                    moveGatewayToGroup($event, entity, tableConfiguration);
                }
            },
            {
                name: access == types.access.admin ? 'credentials.manage' : 'credentials.view',
                icon: 'security',
                isEnabled: () => {
                    return true;
                },
                onAction: ($event, entity) => {
                    var isReadOnly = access == types.access.user ? true : false;
                    manageCredentials($event, entity, isReadOnly);
                }
            }
        ];

        tableConfiguration.groupActionDescriptors = [
            {
                name: 'gateway.move-to-gateway-group',
                icon: 'swap_vertical_circle',
                isEnabled: () => {
                    return access == types.access.admin;
                },
                onAction: ($event, entities) => {
                    moveGatewaysToGroup($event, entities, tableConfiguration);
                }
            }
        ];

        utils.tableConfigDefaults(tableConfiguration);

        return tableConfiguration;
    }

    function loadGateways($scope, gatewayGroupId) {
        var deferred = $q.defer();
        unsubscribeFromGatewayStates();
        gatewayService.getGatewayGroupGateways(gatewayGroupId).then(
            (gateways) => {
                deferred.resolve(gateways);
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function unsubscribeFromGatewayStates() {
        for (var id in gatewayStateSubscriptions) {
            gatewayStateSubscriptions[id]();
        }
        gatewayStateSubscriptions = {};
    }

    function subscribeForGatewaysState($scope, gateways) {
        gateways.forEach(
            (gateway) => {
                if (angular.isUndefined(gatewayStateSubscriptions[gateway.id.id])){
                    gatewayStateSubscriptions[gateway.id.id] = gatewayService.subscribeForGatewayStateData(gateway.id.id,
                        (gatewayState) => {
                            var result = $filter('filter')(gateways, {id: {id: gateway.id.id} }, true);
                            if (result && result.length) {
                                var entity = result[0];
                                $scope.$apply(() => {
                                    entity.online = gatewayState.online;
                                });
                            }
                        }
                    );
                }
            }
        );
    }

    function getTitle(scope, entityTitle) {
        var title = $translate.instant('gateway.gateways');
        if (entityTitle && entityTitle.length) {
            title = entityTitle + ': ' + title;
        }
        return title;
    }

    function moveGatewayToGroup($event, gateway, tableConfiguration) {
        var onEntitySelected = (targetGatewayGroupId) => {
            gateway.gatewayGroupId = targetGatewayGroupId;
            return gatewayService.saveGateway(gateway);
        };
        tkDialogs.selectEntity($event, types.entityType.gateway_group,
            'gateway.move-to-gateway-group', 'action.move',
            'gateway.select-target-move-gateway-group-text',
            'gateway-group.gateway-group-not-found-text',
            'gateway-group.target-gateway-group-required-text', onEntitySelected).then(
            () => { tableConfiguration.reloadEntities(true); }
        );
    }

    function moveGatewaysToGroup($event, gateways, tableConfiguration) {
        var onEntitySelected = (targetGatewayGroupId) => {
            var tasks = [];
            gateways.forEach((gateway) => {
                gateway.gatewayGroupId = targetGatewayGroupId;
                tasks.push(gatewayService.saveGateway(gateway));
            });
            return $q.all(tasks);
        };
        tkDialogs.selectEntity($event, types.entityType.gateway_group,
            'gateway.move-to-gateway-group', 'action.move',
            'gateway.select-target-move-gateway-group-gateways-text',
            'gateway-group.gateway-group-not-found-text',
            'gateway-group.target-gateway-group-required-text', onEntitySelected).then(
            () => { tableConfiguration.reloadEntities(true); }
        );
    }

    function manageCredentials($event, gateway, isReadOnly) {
        tkDialogs.manageCredentials($event, gateway, isReadOnly);
    }


}


// WEBPACK FOOTER //
// ./src/app/gateway/gateway-table.config.js